import { useContext, useEffect } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { isEmpty } from '../../../../library/Core/SmartFunctions';
import useRecruiterDashboard from './useRecruiterDashboard';
import BarChartCommonComponent from '../../../../library/SimpleControls/BarChartCommonComponent';

const RecruiterCompanies = () => {
    const { state } = useContext(SmartContext);
    const { getRecruiterCompanies } = useRecruiterDashboard();

    useEffect(() => {
        getRecruiterCompanies();
    }, [state.data.searchCriteria.recruiterCompanies]);

    if (isEmpty(state.data?.reportData?.recruiterCompanies))
    return (
        <>
            <div>No Data Available</div>
        </>
    );

    return (
        <>
            <BarChartCommonComponent data={state.data.reportData.recruiterCompanies} />
        </>
    );
};

export default RecruiterCompanies;
